const adminSearchJobsList = {
	urlGET: "api/service/jobs/:serviceId",
	idKey: "_id",
	listenEvent: "jobsRevision",
	segmentKey: "ADMIN_SEARCH_JOBS",
	content: {
		grid: {
			tilesPerRow: 2,
			itemsPerRow: 2,
		},
		table: {
			variant: "skinny",
			orderBy: ["id"],
		},
		pagination: {
			enabled: false,
			resetScroll: true,
		},
		order: {
			defaut: {
				key: "id",
				dir: "desc",
			},
		},
		filters: {
			search: false,
			items: [
				{
					key: "status",
					type: "select",
					label: "Status",
					defaultValue: "__NOT_SELECTED__",
					options: [
						{
							value: "__NOT_SELECTED__",
							label: "Not Selected",
						},
						{
							value: "WAITING",
							label: "Waiting",
						},
						{
							value: "ACTIVE",
							label: "Active",
						},
						{
							value: "DELAYED",
							label: "Delayed",
						},
					],
				},
			],
		},
		groups: {},
		items: [
			{
				key: "id",
				type: "id",
				label: "ID",
			},
			{
				key: "data",
				type: "text",
				label: "Type",
				builder: (item) => item?.data?.type,
			},
			{
				key: "data",
				type: "text",
				label: "Search ID",
				builder: (item) => item?.data?.searchId,
			},
			{
				key: "status",
				type: "text",
				label: "Status",
			},
			{
				key: "menu",
				type: "menu",
				label: "Menu",
				items: [
					{
						key: "go_to_search",
						label: "Go to Search",
						newTab: true,
						redirectURLBuilder: (item) => `/search?id=${item?.data?.searchId}`,
						isVisible: (item) => !!item?.data?.searchId,
					},
					{
						key: "retrigger_search",
						label: "Re-Trigger Search",
						isVisible: (item) => !!item?.data?.searchId,
						dialogBuilder: (item) => ({
							viewId: "CONFIRM_DIALOG",
							mode: "CREATE",
							dataIds: {
								title: "Re-Trigger Search",
								message: `This will create a new search using the same filters as search (${item?.data?.searchId}).`,
								confirmLabel: "Re-Trigger",
								url: `api/search/requests/${item?.data?.searchId}/retrigger`,
								method: "POST",
								listenEvent: "searchRevision",
							},
						}),
					},
					{
						key: "force_expire",
						label: "Force Expire",
						isVisible: (item) => !!item?.data?.searchId,
						dialogBuilder: (item) => ({
							viewId: "CONFIRM_DIALOG",
							mode: "DELETE",
							dataIds: {
								title: "Force Expire Search",
								message: `Are you sure you want to force expire this search (${item?.data?.searchId})? This action cannot be undone.`,
								confirmLabel: "Expire",
								url: `api/search/requests/${item?.data?.searchId}/force-expire`,
								listenEvent: "searchRevision",
							},
						}),
					},
				],
			},
		],
	},
};

export default adminSearchJobsList;
